/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkApplyCalculationTemplateDto } from '../models/work-apply-calculation-template-dto';
import { WorkCalculationTemplate } from '../models/work-calculation-template';
import { WorkCalculationTemplateOverviewDto } from '../models/work-calculation-template-overview-dto';
import { WorkCreateCalculationTemplateDto } from '../models/work-create-calculation-template-dto';
import { WorkCreateCalculationTemplateFromCalculationDto } from '../models/work-create-calculation-template-from-calculation-dto';
import { WorkCreateCalculationTemplateGroupDto } from '../models/work-create-calculation-template-group-dto';
import { WorkCreateCalculationTemplateItemDto } from '../models/work-create-calculation-template-item-dto';
import { WorkCreateCalculationTemplateVariableDto } from '../models/work-create-calculation-template-variable-dto';
import { WorkDropdownOptionDto } from '../models/work-dropdown-option-dto';
import { WorkDuplicateCalculationTemplateDto } from '../models/work-duplicate-calculation-template-dto';
import { WorkPaginatedDocumented } from '../models/work-paginated-documented';
import { WorkUpdateCalculationTemplateDto } from '../models/work-update-calculation-template-dto';
import { WorkUpdateCalculationTemplateGroupDto } from '../models/work-update-calculation-template-group-dto';
import { WorkUpdateCalculationTemplateItemDto } from '../models/work-update-calculation-template-item-dto';
import { WorkUpdateCalculationTemplateItemSortOrderDto } from '../models/work-update-calculation-template-item-sort-order-dto';
import { WorkUpdateCalculationTemplateVariableDto } from '../models/work-update-calculation-template-variable-dto';

@Injectable({ providedIn: 'root' })
export class WorkCalculationTemplatesV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `calculationTemplatesV2ControllerFindAllActiveForContainertypeId()` */
  static readonly CalculationTemplatesV2ControllerFindAllActiveForContainertypeIdPath = '/v2/calculation-templates/for-containertype/{containertypeId}';

  /**
   * Required permissions: projects:read, projects:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `calculationTemplatesV2ControllerFindAllActiveForContainertypeId()` instead.
   *
   * This method doesn't expect any request body.
   */
  calculationTemplatesV2ControllerFindAllActiveForContainertypeId$Response(
    params: {
      containertypeId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkCalculationTemplate>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkCalculationTemplatesV2Service.CalculationTemplatesV2ControllerFindAllActiveForContainertypeIdPath, 'get');
    if (params) {
      rb.path('containertypeId', params.containertypeId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkCalculationTemplate>>;
      })
    );
  }

  /**
   * Required permissions: projects:read, projects:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `calculationTemplatesV2ControllerFindAllActiveForContainertypeId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  calculationTemplatesV2ControllerFindAllActiveForContainertypeId(
    params: {
      containertypeId: number;
    },
    context?: HttpContext
  ): Observable<Array<WorkCalculationTemplate>> {
    return this.calculationTemplatesV2ControllerFindAllActiveForContainertypeId$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkCalculationTemplate>>): Array<WorkCalculationTemplate> => r.body)
    );
  }

  /** Path part for operation `calculationTemplatesV2ControllerGetDropdownOptions()` */
  static readonly CalculationTemplatesV2ControllerGetDropdownOptionsPath = '/v2/calculation-templates/dropdown-options/{containertypeId}';

  /**
   * Required permissions: projects:read, projects:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `calculationTemplatesV2ControllerGetDropdownOptions()` instead.
   *
   * This method doesn't expect any request body.
   */
  calculationTemplatesV2ControllerGetDropdownOptions$Response(
    params: {
      containertypeId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkDropdownOptionDto>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkCalculationTemplatesV2Service.CalculationTemplatesV2ControllerGetDropdownOptionsPath, 'get');
    if (params) {
      rb.path('containertypeId', params.containertypeId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkDropdownOptionDto>>;
      })
    );
  }

  /**
   * Required permissions: projects:read, projects:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `calculationTemplatesV2ControllerGetDropdownOptions$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  calculationTemplatesV2ControllerGetDropdownOptions(
    params: {
      containertypeId: number;
    },
    context?: HttpContext
  ): Observable<Array<WorkDropdownOptionDto>> {
    return this.calculationTemplatesV2ControllerGetDropdownOptions$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkDropdownOptionDto>>): Array<WorkDropdownOptionDto> => r.body)
    );
  }

  /** Path part for operation `calculationTemplatesV2ControllerFindAllOverview()` */
  static readonly CalculationTemplatesV2ControllerFindAllOverviewPath = '/v2/calculation-templates/overview';

  /**
   * Required permissions: calculation-templates:read, calculation-templates:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `calculationTemplatesV2ControllerFindAllOverview()` instead.
   *
   * This method doesn't expect any request body.
   */
  calculationTemplatesV2ControllerFindAllOverview$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkCalculationTemplateOverviewDto>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkCalculationTemplatesV2Service.CalculationTemplatesV2ControllerFindAllOverviewPath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkCalculationTemplateOverviewDto>>;
      })
    );
  }

  /**
   * Required permissions: calculation-templates:read, calculation-templates:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `calculationTemplatesV2ControllerFindAllOverview$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  calculationTemplatesV2ControllerFindAllOverview(
    params?: {
    },
    context?: HttpContext
  ): Observable<Array<WorkCalculationTemplateOverviewDto>> {
    return this.calculationTemplatesV2ControllerFindAllOverview$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkCalculationTemplateOverviewDto>>): Array<WorkCalculationTemplateOverviewDto> => r.body)
    );
  }

  /** Path part for operation `calculationTemplatesV2ControllerFindAllPaginated()` */
  static readonly CalculationTemplatesV2ControllerFindAllPaginatedPath = '/v2/calculation-templates';

  /**
   * Required permissions: calculation-templates:read, calculation-templates:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `calculationTemplatesV2ControllerFindAllPaginated()` instead.
   *
   * This method doesn't expect any request body.
   */
  calculationTemplatesV2ControllerFindAllPaginated$Response(
    params?: {

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 100
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 500
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Filter by containertypeId query param.
     *           <p>
     *              <b>Format: </b> filter.containertypeId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.containertypeId=$not:$like:John Doe&filter.containertypeId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li>
     * <li>$in</li>
     * <li>$null</li></ul>
     */
      'filter.containertypeId'?: Array<string>;

    /**
     * Filter by active query param.
     *           <p>
     *              <b>Format: </b> filter.active={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.active=$not:$like:John Doe&filter.active=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.active'?: Array<string>;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> containertypeId:ASC,sortOrder:ASC,name:ASC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>id</li>
     * <li>name</li>
     * <li>containertypeId</li>
     * <li>sortOrder</li>
     * <li>active</li>
     * <li>modified</li></ul>
     */
      sortBy?: Array<'id:ASC' | 'id:DESC' | 'name:ASC' | 'name:DESC' | 'containertypeId:ASC' | 'containertypeId:DESC' | 'sortOrder:ASC' | 'sortOrder:DESC' | 'active:ASC' | 'active:DESC' | 'modified:ASC' | 'modified:DESC'>;

    /**
     * Search term to filter result values
     *         <p>
     *              <b>Example: </b> John
     *           </p>
     *         <p>
     *              <b>Default Value: </b> No default value
     *           </p>
     */
      search?: string;

    /**
     * List of fields to search by term to filter result values
     *         <p>
     *              <b>Example: </b> name,description
     *           </p>
     *         <p>
     *              <b>Default Value: </b> By default all fields mentioned below will be used to search by term
     *           </p>
     *         <h4>Available Fields</h4><ul><li>name</li>
     * <li>description</li></ul>
     */
      searchBy?: Array<string>;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkCalculationTemplate>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'containertypeId'?: (string | Array<string>);
'active'?: (string | Array<string>);
};
};
}>> {
    const rb = new RequestBuilder(this.rootUrl, WorkCalculationTemplatesV2Service.CalculationTemplatesV2ControllerFindAllPaginatedPath, 'get');
    if (params) {
      rb.query('page', params.page, {});
      rb.query('limit', params.limit, {});
      rb.query('filter.containertypeId', params['filter.containertypeId'], {});
      rb.query('filter.active', params['filter.active'], {});
      rb.query('sortBy', params.sortBy, {});
      rb.query('search', params.search, {});
      rb.query('searchBy', params.searchBy, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkPaginatedDocumented & {
        'data'?: Array<WorkCalculationTemplate>;
        'meta'?: {
        'select'?: Array<string>;
        'filter'?: {
        'containertypeId'?: (string | Array<string>);
        'active'?: (string | Array<string>);
        };
        };
        }>;
      })
    );
  }

  /**
   * Required permissions: calculation-templates:read, calculation-templates:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `calculationTemplatesV2ControllerFindAllPaginated$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  calculationTemplatesV2ControllerFindAllPaginated(
    params?: {

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 100
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 500
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Filter by containertypeId query param.
     *           <p>
     *              <b>Format: </b> filter.containertypeId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.containertypeId=$not:$like:John Doe&filter.containertypeId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li>
     * <li>$in</li>
     * <li>$null</li></ul>
     */
      'filter.containertypeId'?: Array<string>;

    /**
     * Filter by active query param.
     *           <p>
     *              <b>Format: </b> filter.active={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.active=$not:$like:John Doe&filter.active=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.active'?: Array<string>;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> containertypeId:ASC,sortOrder:ASC,name:ASC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>id</li>
     * <li>name</li>
     * <li>containertypeId</li>
     * <li>sortOrder</li>
     * <li>active</li>
     * <li>modified</li></ul>
     */
      sortBy?: Array<'id:ASC' | 'id:DESC' | 'name:ASC' | 'name:DESC' | 'containertypeId:ASC' | 'containertypeId:DESC' | 'sortOrder:ASC' | 'sortOrder:DESC' | 'active:ASC' | 'active:DESC' | 'modified:ASC' | 'modified:DESC'>;

    /**
     * Search term to filter result values
     *         <p>
     *              <b>Example: </b> John
     *           </p>
     *         <p>
     *              <b>Default Value: </b> No default value
     *           </p>
     */
      search?: string;

    /**
     * List of fields to search by term to filter result values
     *         <p>
     *              <b>Example: </b> name,description
     *           </p>
     *         <p>
     *              <b>Default Value: </b> By default all fields mentioned below will be used to search by term
     *           </p>
     *         <h4>Available Fields</h4><ul><li>name</li>
     * <li>description</li></ul>
     */
      searchBy?: Array<string>;
    },
    context?: HttpContext
  ): Observable<WorkPaginatedDocumented & {
'data'?: Array<WorkCalculationTemplate>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'containertypeId'?: (string | Array<string>);
'active'?: (string | Array<string>);
};
};
}> {
    return this.calculationTemplatesV2ControllerFindAllPaginated$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkCalculationTemplate>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'containertypeId'?: (string | Array<string>);
'active'?: (string | Array<string>);
};
};
}>): WorkPaginatedDocumented & {
'data'?: Array<WorkCalculationTemplate>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'containertypeId'?: (string | Array<string>);
'active'?: (string | Array<string>);
};
};
} => r.body)
    );
  }

  /** Path part for operation `calculationTemplatesV2ControllerCreate()` */
  static readonly CalculationTemplatesV2ControllerCreatePath = '/v2/calculation-templates';

  /**
   * Required permissions: calculation-templates:create, calculation-templates:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `calculationTemplatesV2ControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  calculationTemplatesV2ControllerCreate$Response(
    params: {
      body: WorkCreateCalculationTemplateDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkCalculationTemplate>> {
    const rb = new RequestBuilder(this.rootUrl, WorkCalculationTemplatesV2Service.CalculationTemplatesV2ControllerCreatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkCalculationTemplate>;
      })
    );
  }

  /**
   * Required permissions: calculation-templates:create, calculation-templates:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `calculationTemplatesV2ControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  calculationTemplatesV2ControllerCreate(
    params: {
      body: WorkCreateCalculationTemplateDto
    },
    context?: HttpContext
  ): Observable<WorkCalculationTemplate> {
    return this.calculationTemplatesV2ControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkCalculationTemplate>): WorkCalculationTemplate => r.body)
    );
  }

  /** Path part for operation `calculationTemplatesV2ControllerFindOneById()` */
  static readonly CalculationTemplatesV2ControllerFindOneByIdPath = '/v2/calculation-templates/{id}';

  /**
   * Required permissions: projects:read, projects:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `calculationTemplatesV2ControllerFindOneById()` instead.
   *
   * This method doesn't expect any request body.
   */
  calculationTemplatesV2ControllerFindOneById$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkCalculationTemplate>> {
    const rb = new RequestBuilder(this.rootUrl, WorkCalculationTemplatesV2Service.CalculationTemplatesV2ControllerFindOneByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkCalculationTemplate>;
      })
    );
  }

  /**
   * Required permissions: projects:read, projects:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `calculationTemplatesV2ControllerFindOneById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  calculationTemplatesV2ControllerFindOneById(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkCalculationTemplate> {
    return this.calculationTemplatesV2ControllerFindOneById$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkCalculationTemplate>): WorkCalculationTemplate => r.body)
    );
  }

  /** Path part for operation `calculationTemplatesV2ControllerDelete()` */
  static readonly CalculationTemplatesV2ControllerDeletePath = '/v2/calculation-templates/{id}';

  /**
   * Required permissions: calculation-templates:delete, calculation-templates:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `calculationTemplatesV2ControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  calculationTemplatesV2ControllerDelete$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkCalculationTemplatesV2Service.CalculationTemplatesV2ControllerDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Required permissions: calculation-templates:delete, calculation-templates:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `calculationTemplatesV2ControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  calculationTemplatesV2ControllerDelete(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<void> {
    return this.calculationTemplatesV2ControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `calculationTemplatesV2ControllerUpdate()` */
  static readonly CalculationTemplatesV2ControllerUpdatePath = '/v2/calculation-templates/{id}';

  /**
   * Required permissions: calculation-templates:update, calculation-templates:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `calculationTemplatesV2ControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  calculationTemplatesV2ControllerUpdate$Response(
    params: {
      id: number;
      body: WorkUpdateCalculationTemplateDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkCalculationTemplate>> {
    const rb = new RequestBuilder(this.rootUrl, WorkCalculationTemplatesV2Service.CalculationTemplatesV2ControllerUpdatePath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkCalculationTemplate>;
      })
    );
  }

  /**
   * Required permissions: calculation-templates:update, calculation-templates:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `calculationTemplatesV2ControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  calculationTemplatesV2ControllerUpdate(
    params: {
      id: number;
      body: WorkUpdateCalculationTemplateDto
    },
    context?: HttpContext
  ): Observable<WorkCalculationTemplate> {
    return this.calculationTemplatesV2ControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkCalculationTemplate>): WorkCalculationTemplate => r.body)
    );
  }

  /** Path part for operation `calculationTemplatesV2ControllerCreateFromCalculation()` */
  static readonly CalculationTemplatesV2ControllerCreateFromCalculationPath = '/v2/calculation-templates/from-calculation';

  /**
   * Required permissions: calculation-templates:create, calculation-templates:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `calculationTemplatesV2ControllerCreateFromCalculation()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  calculationTemplatesV2ControllerCreateFromCalculation$Response(
    params: {
      body: WorkCreateCalculationTemplateFromCalculationDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkCalculationTemplate>> {
    const rb = new RequestBuilder(this.rootUrl, WorkCalculationTemplatesV2Service.CalculationTemplatesV2ControllerCreateFromCalculationPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkCalculationTemplate>;
      })
    );
  }

  /**
   * Required permissions: calculation-templates:create, calculation-templates:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `calculationTemplatesV2ControllerCreateFromCalculation$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  calculationTemplatesV2ControllerCreateFromCalculation(
    params: {
      body: WorkCreateCalculationTemplateFromCalculationDto
    },
    context?: HttpContext
  ): Observable<WorkCalculationTemplate> {
    return this.calculationTemplatesV2ControllerCreateFromCalculation$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkCalculationTemplate>): WorkCalculationTemplate => r.body)
    );
  }

  /** Path part for operation `calculationTemplatesV2ControllerDuplicate()` */
  static readonly CalculationTemplatesV2ControllerDuplicatePath = '/v2/calculation-templates/{id}/duplicate';

  /**
   * Required permissions: calculation-templates:create, calculation-templates:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `calculationTemplatesV2ControllerDuplicate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  calculationTemplatesV2ControllerDuplicate$Response(
    params: {
      id: number;
      body: WorkDuplicateCalculationTemplateDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkCalculationTemplate>> {
    const rb = new RequestBuilder(this.rootUrl, WorkCalculationTemplatesV2Service.CalculationTemplatesV2ControllerDuplicatePath, 'post');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkCalculationTemplate>;
      })
    );
  }

  /**
   * Required permissions: calculation-templates:create, calculation-templates:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `calculationTemplatesV2ControllerDuplicate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  calculationTemplatesV2ControllerDuplicate(
    params: {
      id: number;
      body: WorkDuplicateCalculationTemplateDto
    },
    context?: HttpContext
  ): Observable<WorkCalculationTemplate> {
    return this.calculationTemplatesV2ControllerDuplicate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkCalculationTemplate>): WorkCalculationTemplate => r.body)
    );
  }

  /** Path part for operation `calculationTemplatesV2ControllerApply()` */
  static readonly CalculationTemplatesV2ControllerApplyPath = '/v2/calculation-templates/apply';

  /**
   * Required permissions: projects:update, projects:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `calculationTemplatesV2ControllerApply()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  calculationTemplatesV2ControllerApply$Response(
    params: {
      body: WorkApplyCalculationTemplateDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<boolean>> {
    const rb = new RequestBuilder(this.rootUrl, WorkCalculationTemplatesV2Service.CalculationTemplatesV2ControllerApplyPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as StrictHttpResponse<boolean>;
      })
    );
  }

  /**
   * Required permissions: projects:update, projects:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `calculationTemplatesV2ControllerApply$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  calculationTemplatesV2ControllerApply(
    params: {
      body: WorkApplyCalculationTemplateDto
    },
    context?: HttpContext
  ): Observable<boolean> {
    return this.calculationTemplatesV2ControllerApply$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `calculationTemplatesV2ControllerUpdateItemSortOrder()` */
  static readonly CalculationTemplatesV2ControllerUpdateItemSortOrderPath = '/v2/calculation-templates/items/sort-order';

  /**
   * Required permissions: calculation-templates:update, calculation-templates:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `calculationTemplatesV2ControllerUpdateItemSortOrder()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  calculationTemplatesV2ControllerUpdateItemSortOrder$Response(
    params: {
      body: WorkUpdateCalculationTemplateItemSortOrderDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkCalculationTemplate>> {
    const rb = new RequestBuilder(this.rootUrl, WorkCalculationTemplatesV2Service.CalculationTemplatesV2ControllerUpdateItemSortOrderPath, 'patch');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkCalculationTemplate>;
      })
    );
  }

  /**
   * Required permissions: calculation-templates:update, calculation-templates:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `calculationTemplatesV2ControllerUpdateItemSortOrder$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  calculationTemplatesV2ControllerUpdateItemSortOrder(
    params: {
      body: WorkUpdateCalculationTemplateItemSortOrderDto
    },
    context?: HttpContext
  ): Observable<WorkCalculationTemplate> {
    return this.calculationTemplatesV2ControllerUpdateItemSortOrder$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkCalculationTemplate>): WorkCalculationTemplate => r.body)
    );
  }

  /** Path part for operation `calculationTemplatesV2ControllerCreateGroup()` */
  static readonly CalculationTemplatesV2ControllerCreateGroupPath = '/v2/calculation-templates/groups';

  /**
   * Required permissions: calculation-templates:update, calculation-templates:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `calculationTemplatesV2ControllerCreateGroup()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  calculationTemplatesV2ControllerCreateGroup$Response(
    params: {
      body: WorkCreateCalculationTemplateGroupDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkCalculationTemplate>> {
    const rb = new RequestBuilder(this.rootUrl, WorkCalculationTemplatesV2Service.CalculationTemplatesV2ControllerCreateGroupPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkCalculationTemplate>;
      })
    );
  }

  /**
   * Required permissions: calculation-templates:update, calculation-templates:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `calculationTemplatesV2ControllerCreateGroup$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  calculationTemplatesV2ControllerCreateGroup(
    params: {
      body: WorkCreateCalculationTemplateGroupDto
    },
    context?: HttpContext
  ): Observable<WorkCalculationTemplate> {
    return this.calculationTemplatesV2ControllerCreateGroup$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkCalculationTemplate>): WorkCalculationTemplate => r.body)
    );
  }

  /** Path part for operation `calculationTemplatesV2ControllerDeleteGroup()` */
  static readonly CalculationTemplatesV2ControllerDeleteGroupPath = '/v2/calculation-templates/groups/{id}';

  /**
   * Required permissions: calculation-templates:update, calculation-templates:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `calculationTemplatesV2ControllerDeleteGroup()` instead.
   *
   * This method doesn't expect any request body.
   */
  calculationTemplatesV2ControllerDeleteGroup$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkCalculationTemplate>> {
    const rb = new RequestBuilder(this.rootUrl, WorkCalculationTemplatesV2Service.CalculationTemplatesV2ControllerDeleteGroupPath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkCalculationTemplate>;
      })
    );
  }

  /**
   * Required permissions: calculation-templates:update, calculation-templates:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `calculationTemplatesV2ControllerDeleteGroup$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  calculationTemplatesV2ControllerDeleteGroup(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkCalculationTemplate> {
    return this.calculationTemplatesV2ControllerDeleteGroup$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkCalculationTemplate>): WorkCalculationTemplate => r.body)
    );
  }

  /** Path part for operation `calculationTemplatesV2ControllerUpdateGroup()` */
  static readonly CalculationTemplatesV2ControllerUpdateGroupPath = '/v2/calculation-templates/groups/{id}';

  /**
   * Required permissions: calculation-templates:update, calculation-templates:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `calculationTemplatesV2ControllerUpdateGroup()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  calculationTemplatesV2ControllerUpdateGroup$Response(
    params: {
      id: number;
      body: WorkUpdateCalculationTemplateGroupDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkCalculationTemplate>> {
    const rb = new RequestBuilder(this.rootUrl, WorkCalculationTemplatesV2Service.CalculationTemplatesV2ControllerUpdateGroupPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkCalculationTemplate>;
      })
    );
  }

  /**
   * Required permissions: calculation-templates:update, calculation-templates:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `calculationTemplatesV2ControllerUpdateGroup$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  calculationTemplatesV2ControllerUpdateGroup(
    params: {
      id: number;
      body: WorkUpdateCalculationTemplateGroupDto
    },
    context?: HttpContext
  ): Observable<WorkCalculationTemplate> {
    return this.calculationTemplatesV2ControllerUpdateGroup$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkCalculationTemplate>): WorkCalculationTemplate => r.body)
    );
  }

  /** Path part for operation `calculationTemplatesV2ControllerCreateItem()` */
  static readonly CalculationTemplatesV2ControllerCreateItemPath = '/v2/calculation-templates/items';

  /**
   * Required permissions: calculation-templates:update, calculation-templates:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `calculationTemplatesV2ControllerCreateItem()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  calculationTemplatesV2ControllerCreateItem$Response(
    params: {
      body: WorkCreateCalculationTemplateItemDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkCalculationTemplate>> {
    const rb = new RequestBuilder(this.rootUrl, WorkCalculationTemplatesV2Service.CalculationTemplatesV2ControllerCreateItemPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkCalculationTemplate>;
      })
    );
  }

  /**
   * Required permissions: calculation-templates:update, calculation-templates:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `calculationTemplatesV2ControllerCreateItem$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  calculationTemplatesV2ControllerCreateItem(
    params: {
      body: WorkCreateCalculationTemplateItemDto
    },
    context?: HttpContext
  ): Observable<WorkCalculationTemplate> {
    return this.calculationTemplatesV2ControllerCreateItem$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkCalculationTemplate>): WorkCalculationTemplate => r.body)
    );
  }

  /** Path part for operation `calculationTemplatesV2ControllerDeleteItem()` */
  static readonly CalculationTemplatesV2ControllerDeleteItemPath = '/v2/calculation-templates/items/{id}';

  /**
   * Required permissions: calculation-templates:update, calculation-templates:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `calculationTemplatesV2ControllerDeleteItem()` instead.
   *
   * This method doesn't expect any request body.
   */
  calculationTemplatesV2ControllerDeleteItem$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkCalculationTemplate>> {
    const rb = new RequestBuilder(this.rootUrl, WorkCalculationTemplatesV2Service.CalculationTemplatesV2ControllerDeleteItemPath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkCalculationTemplate>;
      })
    );
  }

  /**
   * Required permissions: calculation-templates:update, calculation-templates:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `calculationTemplatesV2ControllerDeleteItem$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  calculationTemplatesV2ControllerDeleteItem(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkCalculationTemplate> {
    return this.calculationTemplatesV2ControllerDeleteItem$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkCalculationTemplate>): WorkCalculationTemplate => r.body)
    );
  }

  /** Path part for operation `calculationTemplatesV2ControllerUpdateItem()` */
  static readonly CalculationTemplatesV2ControllerUpdateItemPath = '/v2/calculation-templates/items/{id}';

  /**
   * Required permissions: calculation-templates:update, calculation-templates:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `calculationTemplatesV2ControllerUpdateItem()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  calculationTemplatesV2ControllerUpdateItem$Response(
    params: {
      id: number;
      body: WorkUpdateCalculationTemplateItemDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkCalculationTemplate>> {
    const rb = new RequestBuilder(this.rootUrl, WorkCalculationTemplatesV2Service.CalculationTemplatesV2ControllerUpdateItemPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkCalculationTemplate>;
      })
    );
  }

  /**
   * Required permissions: calculation-templates:update, calculation-templates:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `calculationTemplatesV2ControllerUpdateItem$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  calculationTemplatesV2ControllerUpdateItem(
    params: {
      id: number;
      body: WorkUpdateCalculationTemplateItemDto
    },
    context?: HttpContext
  ): Observable<WorkCalculationTemplate> {
    return this.calculationTemplatesV2ControllerUpdateItem$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkCalculationTemplate>): WorkCalculationTemplate => r.body)
    );
  }

  /** Path part for operation `calculationTemplatesV2ControllerCreateVariable()` */
  static readonly CalculationTemplatesV2ControllerCreateVariablePath = '/v2/calculation-templates/variables';

  /**
   * Required permissions: calculation-templates:update, calculation-templates:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `calculationTemplatesV2ControllerCreateVariable()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  calculationTemplatesV2ControllerCreateVariable$Response(
    params: {
      body: WorkCreateCalculationTemplateVariableDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkCalculationTemplate>> {
    const rb = new RequestBuilder(this.rootUrl, WorkCalculationTemplatesV2Service.CalculationTemplatesV2ControllerCreateVariablePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkCalculationTemplate>;
      })
    );
  }

  /**
   * Required permissions: calculation-templates:update, calculation-templates:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `calculationTemplatesV2ControllerCreateVariable$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  calculationTemplatesV2ControllerCreateVariable(
    params: {
      body: WorkCreateCalculationTemplateVariableDto
    },
    context?: HttpContext
  ): Observable<WorkCalculationTemplate> {
    return this.calculationTemplatesV2ControllerCreateVariable$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkCalculationTemplate>): WorkCalculationTemplate => r.body)
    );
  }

  /** Path part for operation `calculationTemplatesV2ControllerDeleteVariable()` */
  static readonly CalculationTemplatesV2ControllerDeleteVariablePath = '/v2/calculation-templates/variables/{id}';

  /**
   * Required permissions: calculation-templates:update, calculation-templates:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `calculationTemplatesV2ControllerDeleteVariable()` instead.
   *
   * This method doesn't expect any request body.
   */
  calculationTemplatesV2ControllerDeleteVariable$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkCalculationTemplate>> {
    const rb = new RequestBuilder(this.rootUrl, WorkCalculationTemplatesV2Service.CalculationTemplatesV2ControllerDeleteVariablePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkCalculationTemplate>;
      })
    );
  }

  /**
   * Required permissions: calculation-templates:update, calculation-templates:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `calculationTemplatesV2ControllerDeleteVariable$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  calculationTemplatesV2ControllerDeleteVariable(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkCalculationTemplate> {
    return this.calculationTemplatesV2ControllerDeleteVariable$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkCalculationTemplate>): WorkCalculationTemplate => r.body)
    );
  }

  /** Path part for operation `calculationTemplatesV2ControllerUpdateVariable()` */
  static readonly CalculationTemplatesV2ControllerUpdateVariablePath = '/v2/calculation-templates/variables/{id}';

  /**
   * Required permissions: calculation-templates:update, calculation-templates:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `calculationTemplatesV2ControllerUpdateVariable()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  calculationTemplatesV2ControllerUpdateVariable$Response(
    params: {
      id: number;
      body: WorkUpdateCalculationTemplateVariableDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkCalculationTemplate>> {
    const rb = new RequestBuilder(this.rootUrl, WorkCalculationTemplatesV2Service.CalculationTemplatesV2ControllerUpdateVariablePath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkCalculationTemplate>;
      })
    );
  }

  /**
   * Required permissions: calculation-templates:update, calculation-templates:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `calculationTemplatesV2ControllerUpdateVariable$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  calculationTemplatesV2ControllerUpdateVariable(
    params: {
      id: number;
      body: WorkUpdateCalculationTemplateVariableDto
    },
    context?: HttpContext
  ): Observable<WorkCalculationTemplate> {
    return this.calculationTemplatesV2ControllerUpdateVariable$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkCalculationTemplate>): WorkCalculationTemplate => r.body)
    );
  }

}
